<template>
  <div class="main-container" v-if="!isLoading">
    <div class="main-container-title-box">
      <div class="d-flex justify-center align-center">
        <div class="container-main-header-button">
          <v-btn depressed @click="back">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <span>Редактировать ответ</span>
        </div>
        <div></div>
      </div>
    </div>

    <div class="main-container-info-box">
      <div class="info-block">
        <div class="info-block-title">Вопрос</div>
        <div>
          <v-text-field
            label="Автор"
            type="text"
            outlined
            v-model="fullQuestionAuthorName"
            disabled
          ></v-text-field>
        </div>
        <div>
          <v-textarea
            label="Редактировать вопрос"
            type="text"
            row="1"
            auto-grow
            outlined
            v-model="question.question"
          ></v-textarea>
        </div>
        <div v-if="question.answers?.length">
          <div class="info-block-title">Ответы</div>
          <div
            class="questions-wrapper"
            v-for="(item, index) in question.answers"
            :key="index"
          >
            <div>
              <div class="info-block-text d-flex justify-space-between mb-4">
                <div class="answer-count">
                  {{ `Ответ ${index + 1}` }}
                </div>
                <div class="delete-answer">
                  <v-icon
                    class="answers-icon-delete"
                    @click="deleteAnswer(item)"
                    color="var(--app-red-1)"
                  >
                    mdi-delete-outline
                  </v-icon>
                </div>
              </div>
              <div>
                <v-text-field
                  label="Автор"
                  type="text"
                  outlined
                  :value="fullAnswerAuthorName(item)"
                  disabled
                ></v-text-field>
              </div>
              <div>
                <v-textarea
                  label="Редактировать вопрос"
                  type="text"
                  outlined
                  row="1"
                  auto-grow
                  v-model="item.answer"
                ></v-textarea>
              </div>
            </div>
            <div>
              <ViewBlock label="Реакции отображаемые" labelBackground="#fff">
                <template v-slot:content>
                  <div class="reaction-list">
                    <div
                      v-for="(reaction, index) in item.answerReactions"
                      :key="index"
                      class="reaction-block"
                    >
                      <div class="reaction-img">
                        <img :src="reaction.imagePath" alt="123" />
                      </div>
                      <div class="reaction-count">
                        <input
                          v-model="reaction.fakeNumberToAdd"
                          type="string"
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </ViewBlock>
            </div>
            <div>
              <ViewBlock label="Реакции фактические" labelBackground="#fff">
                <template v-slot:content>
                  <div class="reaction-list">
                    <div
                      v-for="(reaction, index) in item.answerReactions"
                      :key="index"
                      class="reaction-block"
                    >
                      <div class="reaction-img">
                        <img :src="reaction.imagePath" alt="123" />
                      </div>
                      <div class="reaction-count">
                        <input
                          disabled
                          v-model="reaction.numberToAdd"
                          type="string"
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </ViewBlock>
            </div>
            <div class="switch">
              <div class="d-flex align-center mb-8 main-container-info-box">
                <v-switch
                  v-model="item.showRealReactions"
                  hide-details
                  color="var(--app-green-1)"
                ></v-switch>
                <span>Отображать фактические реакции</span>
              </div>
            </div>
          </div>
        </div>

        <div class="container-block-footer-buttons">
          <div>
            <v-btn
              @click.stop="saveQuestion"
              style="width: auto !important"
              class="button-accept"
            >
              Сохранить
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ViewBlock from "@/components/main/ViewBlock.vue";
export default {
  components: {
    ViewBlock,
  },
  data: () => ({
    showInfo: false,
    x: null,
    y: null,
    question: {},
    files: [],
    answersToDelete: [],
    imageWidth: 0,
    newImage: null,
    reactionDialog: false,

    reactionsList: [],

    isLoading: true,

    showBlock: false,
  }),
  computed: {
    fullQuestionAuthorName() {
      return this.question.questionAuthor?.fullName;
    },
  },
  methods: {
    back() {
      this.$emit("goToPage", "DetailReception");
    },
    fullAnswerAuthorName(item) {
      return `${item.answerCandidate.user.lastName} ${item.answerCandidate.user.firstName}`;
    },

    deleteAnswer(item) {
      this.question.answers.splice(this.question.answers.indexOf(item), 1);
      this.answersToDelete.push(item.id);
    },

    successUpdateAlert() {
      this.$store.commit("errorSet", {
        key: true,
        text: "Данные успешно сохранены",
        type: "success",
      });
    },
    async deleteAnswers() {
      const urlParams = new URLSearchParams();
      this.answersToDelete.forEach((id) => {
        urlParams.append("answerIds", id);
      });
      urlParams.append("questionId", this.question.id);
      return await this.$axios
        .delete(
          this.$store.getters.apiAdminPanelV5 +
            `/reception-of-candidates-answers?${urlParams.toString()}`,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          return true;
        })
        .catch(() => {
          return false;
        });
    },
    async saveQuestion() {
      if (this.answersToDelete.length) {
        await this.deleteAnswers();
      }
      const questionBody = {
        id: this.question.id,
        question: this.question.question,
        authorId: this.question.questionAuthor.id,
        moderationStatus: this.question.moderationStatus,
        isFromMobile: this.question.isFromMobile,
        email: this.question.email,
        name: this.question.name,
      };
      this.$axios
        .patch(
          this.$store.getters.apiAdminPanelV5 +
            `/reception-of-candidates-questions`,
          questionBody,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.saveAnswersReactions();
        });
    },

    async saveAnswersReactions() {
      const answers = this.question.answers.map((item) => {
        return {
          id: item.id,
          reactions: item.answerReactions.map((i) => {
            return {
              reactionId: i.reactionId,
              fakeNumberToAdd: Number.parseInt(i.fakeNumberToAdd),
            };
          }),
          moderationStatus: item.moderationStatus,
          showRealReactions: item.showRealReactions,
          answer: item.answer,
          candidateId: item.candidateId,
          questionId: item.questionId,
        };
      });
      this.$axios
        .patch(
          this.$store.getters.apiAdminPanelV5 +
            `/reception-of-candidates-answers`,
          {
            answers: answers,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.successUpdateAlert();
          this.getQuestionAndReactions();
        });
    },

    async getQuestionAndReactions() {
      const [questionRes, reactionsRes] = await Promise.all([
        this.$axios.get(
          this.$store.getters.apiAdminPanelV5 +
            `/reception-of-candidates-questions?questionId=${this.$route.query.questionId}`,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        ),
        this.$axios.get(
          this.$store.getters.apiAdminPanelV5 +
            `/reception-of-candidates-reactions/list`,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        ),
      ]);

      this.question = questionRes.data;

      this.reactionsList = reactionsRes.data;

      this.calculateReactionsCount();
    },

    calculateReactionsCount() {
      const reactionsById = this.reactionsList.reduce(
        (acc, item) => ({
          ...acc,
          [item.id]: item,
        }),
        {}
      );

      for (const answer of this.question.answers) {
        answer.answerReactions = answer.answerReactions.map((ar) => ({
          ...ar,
          imagePath: reactionsById[ar.reactionId]?.imagePath,
        }));

        const answerReactionsIds = answer.answerReactions.map(
          (ar) => ar.reactionId
        );

        const missingReactions = Object.keys(reactionsById).filter(
          (id) => !answerReactionsIds.includes(id)
        );

        answer.answerReactions.push(
          ...missingReactions.map((id) => ({
            reactionId: id,
            numberToAdd: 0,
            fakeNumberToAdd: 0,
            imagePath: reactionsById[id].imagePath,
          }))
        );
      }
      for (const answer of this.question.answers) {
        answer.answerReactions.sort((a, b) =>
          a.reactionId.localeCompare(b.reactionId)
        );
      }
    },
  },
  async created() {
    await this.getQuestionAndReactions().finally(() => {
      this.isLoading = false;
    });
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  .main-container-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 40px 24px;

    .container-main-header-button {
      display: flex;
      align-items: center;

      span {
        font-size: 28px;
        font-weight: 400;
        margin-left: 16px;
      }
    }

    .main-container-title-box-text {
      display: flex;
      align-items: center;

      span {
        font-size: 28px;
        font-weight: 400;
        margin-right: 20px;
      }
    }
  }

  .main-container-info-box {
    .table-title {
      font-size: 24px;
      font-weight: 600;
      margin: 0 24px;
    }

    .info-block {
      width: 50%;
      margin: 0 24px;
      margin-bottom: 50px;

      .info-block-title {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 16px;
      }

      .container-box-text {
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        color: var(--app-dark-grey-1);
        margin-bottom: 16px;
      }

      .info-block-text {
        font-size: 18px;
        font-weight: 400;
      }
      .container-block-footer-buttons {
        display: flex;
        justify-content: space-between;
        width: 50%;
        margin-top: 60px;
      }
    }

    .image-container {
      width: calc(100% - 48px);
      margin: 0 24px;
      margin-bottom: 50px;
    }

    .table-img {
      cursor: pointer;
      height: 38px;
      object-fit: contain;
    }
  }
  .reactions-table {
    margin: 0 24px;
  }
}

.dialog-add-custom {
  .add-wrapper {
    .dialog-title-custom {
      .title-custom {
        font-weight: 500;
        font-size: 24px;
        line-height: 20px;
        color: var(--app-dark-blue-3);
      }
    }
    .dialog-description-custom {
      padding: 0 24px;
      .description-custom {
        font-weight: 400;
        font-size: 18px;
        line-height: 24px;
        color: var(--app-dark-grey-1);
      }
    }
  }
}
.reaction-list {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0 0 0;

  .reaction-block {
    background: rgba(206, 215, 225, 0.447);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    border-radius: 8px;
    margin-right: 10px;
    margin-bottom: 10px;
    .reaction-img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: cover;
      }
    }
    .reaction-count {
      background: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 2px;
      &.background {
        background: var(--app-light-grey);
      }
      input {
        max-width: 40px;
        outline: none;
        border: none;
        padding-left: 5px;
        font-size: 15px;
        background: #fff;
      }
    }
  }
}
</style>
